import { getNotificationAppearance } from "./notificationAppearance.shared";
import { getNotificationNavigationUrl } from "./notificationNavigation.helper";
import { NotificationListResponseType } from "@sellar-io/api-v2/types";
import { twMerge } from "tailwind-merge";
import { useNotificationReadCreate } from "../../hooks/api/v2/notificationRead/useNotificationReadCreate";
import { NotificationGroupContent } from "./NotificationGroupContent";
import { Icon } from "@sellar-io/components";
import { useNavigateToChild } from "../../hooks/useParentNavigation";

export const NotificationGroup = ({
  notification,
  setPopoverActive,
  isNotificationPopover,
}: {
  notification: NotificationListResponseType[number];
  setPopoverActive?: (active: boolean) => void;
  isNotificationPopover: boolean;
}) => {
  const navigateToChild = useNavigateToChild();
  const mutation = useNotificationReadCreate();
  const navigateUrl = getNotificationNavigationUrl(notification);

  const markAsRead = () => {
    if (!!notification.NotificationRead) {
      if (navigateUrl) {
        navigateToChild(navigateUrl);
      }
      return setPopoverActive?.(false);
    }
    mutation.mutate(
      {
        NotificationId: notification.id,
      },
      {
        onSuccess: () => {
          if (navigateUrl) {
            navigateToChild(navigateUrl);
          }
          setPopoverActive?.(false);
        },
      },
    );
  };

  const SenderBusiness = notification.SenderBusiness;
  const logoUrl = SenderBusiness.logoUrl;
  const senderBusinessName = SenderBusiness.name;
  const title = notification.title;
  const description = notification.description;
  const isNotificationRead = !!notification.NotificationRead;
  return (
    <NotificationGroupContent
      isNotificationRead={isNotificationRead}
      description={description}
      title={title}
      senderBusinessName={senderBusinessName}
      logoUrl={logoUrl}
      markAsRead={markAsRead}
      isNotificationPopover={isNotificationPopover}
    >
      {notification.type !== "storefront" && (
        <NotificationIcon notification={notification} />
      )}
    </NotificationGroupContent>
  );
};

const NotificationIcon = ({
  notification,
}: {
  notification: NotificationListResponseType[number];
}) => {
  const { icon, className } = getNotificationAppearance(notification.subtype);

  return (
    <>
      <div
        className={twMerge(
          "absolute top-[26px] left-[25px] inline-flex h-6 w-6 items-center justify-center rounded-3xl p-1 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.15)]",
          className,
        )}
      >
        <Icon icon={icon} />
      </div>
    </>
  );
};
